module.exports = __webpack_public_path__ + "logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/core/components/editor/styled/logo.png
// module id = 2123
// module chunks = 0